import api from '@motionelements/core/src/api/base-api-v2';

const baseUrl = '/v2/libraries';

export function getLibraries() {
  return api.get(baseUrl);
}

export function getFolders(memberName, params, axiosConfig) {
  return api.get(`${baseUrl}/${memberName}/folders`, {
    params,
    ...(axiosConfig || {}),
  });
}

export function followMemberLibrary(hashId, axiosConfig) {
  return api.request('post', `${baseUrl}/${hashId}/follow`, {
    ...(axiosConfig || {}),
  });
}

export function unfollowMemberLibrary(hashId, axiosConfig) {
  return api.request('post', `${baseUrl}/${hashId}/unfollow`, {
    ...(axiosConfig || {}),
  });
}
